import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getDefaultLocale } from "@/i18n";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center space-y-6 p-8">
        <h1 className="text-6xl font-bold text-[#166B93]">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800">Page Not Found</h2>
        <p className="text-gray-600 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to={`/${getDefaultLocale()}`}>
          <Button 
            variant="default"
            size="lg"
            className="bg-[#166B93] hover:bg-[#166B93]/90 text-white shadow-lg"
          >
            Go Back Home
          </Button>
        </Link>
      </div>
    </div>
  );
}

